import React from 'react';

const CARD_LINE_WIDTHS = ['92%', '76%', '88%', '58%'] as const;
const WEEKLY_LINE_WIDTHS = ['90%', '72%', '86%', '64%', '80%', '48%'] as const;

type Props = {
  variant?: 'card' | 'weekly';
  onUnlock?: () => void;
};

const DailyNoteLockedPreview: React.FC<Props> = ({ variant = 'card', onUnlock }) => {
  const lockSrc = `${process.env.PUBLIC_URL || ''}/lock.svg`;
  const widths = variant === 'weekly' ? WEEKLY_LINE_WIDTHS : CARD_LINE_WIDTHS;
  const className =
    'cp-daily-note-card-mask' +
    (variant === 'weekly' ? ' cp-daily-note-card-mask--weekly' : '') +
    (onUnlock ? ' is-unlockable' : '');
  const inner = (
    <>
      <div className="cp-daily-note-card-mask-lines" aria-hidden>
        {widths.map((width, index) => (
          <span key={index} style={{ width }} />
        ))}
      </div>
      <img className="cp-daily-note-card-mask-lock" src={lockSrc} alt="" />
    </>
  );

  if (onUnlock) {
    return (
      <button
        type="button"
        className={className}
        onClick={onUnlock}
        aria-label="잠긴 데일리 노트 보기"
      >
        {inner}
      </button>
    );
  }

  return (
    <div className={className} role="img" aria-label="잠긴 데일리 노트">
      {inner}
    </div>
  );
};

export default DailyNoteLockedPreview;
